import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import HomeProfesor from "../views/HomeProfesor/HomeProfesor.vue";
import GestionCurso from "../views/GestionCurso/GestionCurso.vue";

//BCE Equivalencias

import BceEquivalencia from "../views/Bce/Equivalencia.vue"

// cicuito
import PreInscripcion from "../views/Circuito/PreInscripcion.vue";
import Inscripcion from "../views/Circuito/Inscripcion.vue";
import Circuito from "../views/Circuito/Circuito.vue";
import CircuitoPago from "../views/Circuito/CircuitoPago.vue";
import Validacion from "../views/Circuito/Validacion.vue";
import Clock from "../views/Clock/Clock.vue";
import CircuitoNewversion from "../views/Circuito/CircuitoNewversion.vue"
import CargaArchivo from "../views/Circuito/CargaArchivo.vue";
import Password from "../views/Circuito/Password.vue";
// clases
import MateriaCodigoClaseVideo from "../views/MateriaCodigo/MateriaCodigoClaseVideo";

//examenes
import Examen from "../views/Examen/Examen2.vue"

//change password
import ChangePassword from "../views/ChangePassword/ChangePassword.vue"

//Trámite
import Tramite from "../views/Tramite/Tramite.vue"

//Denuncia
import Denuncia from "../views/Denuncia/Denuncia.vue"

//Consulta
import Consulta from "../views/Consulta/Consulta.vue"

//Documento
import Documento from "../views/Documento/Documento.vue"

//Nota
import Nota from "../views/Nota/Nota.vue"

//Materia
import Materia from "../views/Materia/Materia.vue"

//Mis Materias
import MisMaterias from "../views/MisMaterias/MisMaterias.vue"
import MisMateriasGratis from "../views/MisMaterias/MisMateriasGratis.vue"

import MisMateriasNew from "../views/MisMaterias/MisMateriasnew.vue"
import MateriaDetalle from "../views/MisMaterias/MateriaDetalle.vue"
//Informar pago
import InformarPago from "../views/InformarPago/InformarPago.vue"

//Turnos presenciales
import Turno from "../views/Turno/Presencial.vue"

//Llamadas
import Llamada from "../views/Turno/Llamada.vue"

//Pagar curso
import PaymentCurso from "../views/Payment/Curso.vue"

//Pago regular
import PaymentRegular from "../views/Payment/Regular.vue"

//Publicaciones
import Publicacion from "../views/Publicacion/Publicacion.vue"

//Chat
import Chat from "../views/Chat/Chat.vue"

//ChatProfesor
import ChatProfesor from "../views/ChatProfesor/Chat.vue"

//ChatOperador
import ChatOperador from "../views/ChatOperador/ChatOperador.vue"

//User Profile
import Profile from "../views/Profile/Profile.vue"

//User Profile Empresa
import ProfileEmpresa from "../views/Profile/ProfileEmpresa.vue"

//User Settigs
import Settings from "../views/Settings/Settings.vue"

//Materias optativas
import Optativa from "../views/Optativa/Optativa.vue"

import ResetPassword from "../views/ResetPassword";

//Foro
import Foro from "../views/Foro/Foro.vue"
import ForoDetalle from "../views/Foro/Detalle.vue"

//Recover user
import RecoverUser from "../views/RecoverUser.vue";


// clases
import Clasesv2 from "../views/Clases/Clasesv2.vue";

// subscripciones
import Subscripcion from "../views/Subscripciones/Subscripcion";

// subscripciones externas
import SubscripcionExterna from "../views/Subscripciones/SubscripcionExterna";

//Horario

import Horario from "../views/Horario/Horario.vue";

import Horario2 from "../views/Horario/Horario2.vue";

// Test
import Test from "../views/TestView/Test";

//Secretaria virtual

import Secretaria from "../views/SecretariaVirtual/SecretariaVirtual.vue";
import SecretariaNew from "../views/SecretariaVirtual/SecretariaVirtualnew.vue";

import Calendario from "../views/CalendarioAcademico/CalendarioAcademico.vue";
import CalendarioNew from "../views/CalendarioAcademico/CalendarioAcademiconew.vue";


import Postulaciones from "../views/Postulaciones/Postulaciones.vue"

import BolsaTrabajo from "../views/BolsaTrabajo/BolsaTrabajo.vue"

//entrega de documentos

import DocumentosSolicitados from "../views/DocumentosSolicitados/DocumentosSolicitados.vue"

import ContactoBce from "../views/ContactoBce/ContactoBce.vue";
import ContactoDatos from "../views/ContactoBce/ContactoDatos.vue";

//panels
import InscripcionExamen from "../views/Panel/InscripcionExamen.vue";
import Faltan from "../views/Panel/Faltan.vue";
import ParcialExamen from "../views/Panel/ParcialExamen.vue";
import ForoCategoria from "../views/Foro/ForoCategoria.vue";
PreInscripcion;
Vue.use(VueRouter);

/*const middlewareCircuito = (to, from, next) => {
  // store.dispatch("socketTracking",{type:'route',data:{to:to,from:from}})
  if (to.name != "Circuito") {
    if (store.getters.circuito == "") {
      next({ name: "Circuito", params: { id: 123 } });
      return;
    }

    if (
      store.getters.preinscrito == "" &&
      to.name != "CircuitoPreInscripcion"
    ) {
      next({ name: "CircuitoPreInscripcion" });
      return;
    }

    if (
      store.getters.preinscrito != "" &&
      to.name == "CircuitoPreInscripcion"
    ) {
      next({ name: "CircuitoPago" });
      return;
    }

    if (store.getters.inscripto == "" && to.name == "CircuitoValidacion") {
      next({ name: "Circuito", params: { id: 123 } });
      return;
    }
  }

  next();
};
*/
const ifNotAuthenticated = (to, from, next) => {
  if (store.getters.token == "") {
    next();
    return;
  } else {
    next({ name: "Home" });
  }
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.token != "") {
    next();
  } else {
    next({ name: "Login" });
  }
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/home-profesor",
    name: "HomeProfesor",
    component: HomeProfesor,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/gestion-curso/:cursoId/:cursoNombre",
    name: "GestionCurso",
    component: GestionCurso,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    },
    props: true
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: ifNotAuthenticated
  },

  {
    path: "/chat/gpt",
    name: "Chatgpt",
    component: Chat,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    },
    props: { chatgpt: true }
  },

  {
    path: "/materia/clases/:catedra/:planestudio/:alumno",
    name: "MateriaCodigoClaseVideo",
    component: MateriaCodigoClaseVideo
    // beforeEnter: ifNotAuthenticated
  },

  {
    path: "/materia/clases/:catedra/:planestudio",
    name: "MateriaCodigoClaseVideoAuth",
    component: MateriaCodigoClaseVideo,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Bce Equivalencia

  {
    path: "/equivalencia/bce",
    name: "bceEquivalencia",
    component: BceEquivalencia,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Examenes
  {
    path: "/examen/:test/:examen",
    name: "examen",
    component: Examen,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Change password
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Tramite
  {
    path: "/tramite",
    name: "Tramite",
    component: Tramite,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Denuncia
  {
    path: "/denuncia",
    name: "Denuncia",
    component: Denuncia,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Secretaria Virtual
  {
    path: "/secretaria-virtual",
    name: "Secretaria",
    component: SecretariaNew,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/secretaria-virtual-new",
    name: "SecretariaNew",
    component: Secretaria,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/calendario-academico",
    name: "CalendarioAcademico",
    component: CalendarioNew,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/calendario-academico-new",
    name: "CalendarioAcademicoNew",
    component: Calendario,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  // Postulaciones

  {
    path: "/postulaciones",
    name: "Postulaciones",
    component: Postulaciones,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Consulta
  {
    path: "/consulta",
    name: "Consulta",
    component: Consulta,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Documento
  {
    path: "/Documento",
    name: "Documento",
    component: Documento,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Nota
  {
    path: "/nota",
    name: "Nota",
    component: Nota,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Materia
  {
    path: "/materias",
    name: "Materia",
    component: Materia,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //MisMaterias
  {
    path: "/mis-materias",
    name: "MisMaterias",
    component: MisMateriasNew,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/mi-materia-gratis/:id",
    name: "MiMateriaGratis",
    component: MisMateriasGratis,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/mis-materias-new",
    name: "MisMateriasNew",
    component: MisMaterias,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/mis-materias-new/:materiaId/detalle",
    name: "MisMateriaDetalle",
    component: MateriaDetalle,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //InformarPago
  {
    path: "/informar-pago",
    name: "InformarPago",
    component: InformarPago,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Pagar curso
  {
    path: "/pagar-curso",
    name: "PaymentCurso",
    component: PaymentCurso,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Pago regular
  {
    path: "/pago-regular",
    name: "PaymentRegular",
    component: PaymentRegular,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Publicaciones
  {
    path: "/publicaciones",
    name: "Publicaciones",
    component: Publicacion,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //Publicaciones
  {
    path: "/publicaciones/:id",
    name: "PublicacionDetalle",
    component: Publicacion,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //Publicaciones
  {
    path: "/Publicacion",
    name: "PublicacionLegacy",
    component: Publicacion,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },



  //Chat
  {
    path: "/chat-profesor",
    name: "ChatProfesor",
    component: ChatProfesor,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/chat-operador",
    name: "ChatOperador",
    component: ChatOperador,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Chat-Comunicacion con la institucion
  {
    path: "/chat",
    name: "Chat",
    component: Chat,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    },
    props: { showInfo: false, chatgpt: false }
  },

  {
    path: "/chat/iea/test",
    name: "ChatTest",
    component: Chat,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    },
    props: { chatgpt: false, showInfo: true }
  },
  //Chat 
  {
    path: "/chat/:id",
    name: "ChatDetail",
    component: Chat,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //Chat 
  {
    path: "/chat/user/:userid",
    name: "ChatUser",
    component: Chat,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Chat
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Profile Empresa
  {
    path: "/profile/Empresa",
    name: "ProfileEmpresa",
    component: ProfileEmpresa,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //Chat 
  {
    path: "/profile/:id/:tipo_usuario",
    name: "ProfileDetail",
    component: Profile,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/profile/empresa/:id/:tipo_usuario",
    name: "ProfileEmpresaDetail",
    component: Profile,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //Settings
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  //Materias Optativas
  {
    path: "/optativas",
    name: "Optativa",
    component: Optativa,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Turnos presenciales

  {
    path: "/solicitud-baja",
    name: "Turno",
    component: Turno,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },


  //Horario

  {
    path: "/horario",
    name: "Horario",
    component: Horario,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/horario2",
    name: "Horario2",
    component: Horario2,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //solictud de documentos

  {
    path: "/documentos-solicitados",
    name: "DocumentosSolicitados",
    component: DocumentosSolicitados,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //LLamadas
  {
    path: "/llamadas",
    name: "Llamada",
    component: Llamada,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  // circuitos
  {
    path: "/circuito/init/:id",
    name: "Circuito",
    component: Circuito,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/circuito/preincripcion/:id",
    name: "CircuitoPreInscripcion",
    component: PreInscripcion,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/circuito/preincripcionv2/:id",
    name: "CircuitoPreInscripcionv2",
    component: CircuitoNewversion,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/recuperar-inscripcion",
    name: "CargaArchivo",
    component: CargaArchivo,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/carga-archivo-params/:id/:preinscrito",
    name: "CargaArchivoparams",
    component: CargaArchivo,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/review-pass",
    name: "ReviewPass",
    component: Password,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/circuito/pago/:id/:idML",
    name: "CircuitoPago",
    component: CircuitoPago,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/circuito/callback-pago/:preinscrito",
    name: "CallbackMp",
    component: Circuito,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/circuito/inscripcion/:id/:preinscrito",
    name: "CircuitoInscripcion",
    component: Inscripcion,
    //beforeEnter: middlewareCircuito
  },
  {
    path: "/circuito/validacion",
    name: "CircuitoValidacion",
    component: Validacion,
    //beforeEnter: middlewareCircuito
  },

  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword
  },

  {
    path: "/recover-user",
    name: "RecoverUser",
    component: RecoverUser
  },
  //Foro
  {
    path: "/foro",
    name: "Foro",
    component: Foro,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/foro/:categoria_id",
    name: "ForoCategoria",
    component: ForoCategoria,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/foro/:id",
    name: "ForoDetalle",
    component: ForoDetalle,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "bolsa-trabajo",
    name: "BolsaTrabajo",
    component: BolsaTrabajo,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }

  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  //clases
  {
    path: "/clases",
    name: "Clases",
    component: Clasesv2,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Test
  {
    path: "/Evaluaciones",
    name: "Evaluaciones",
    component: Test,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  //Clock radar
  {
    path: "/kanban",
    name: "Clock",
    component: Clock,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/subscripciones",
    name: "Subscripciones",
    component: Subscripcion,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/registrar-subscripcion/:circuito/:preinscripcion",
    name: "SubscripcionesExternas",
    component: SubscripcionExterna,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/contactoBce",
    name: "ContactoBce",
    component: ContactoBce
    // beforeEnter: ifNotAuthenticated
  },
  {
    path: "/contactoDatos",
    name: "ContactoDatos",
    component: ContactoDatos
    // beforeEnter: ifNotAuthenticated
  },
  {
    path: "/inscripcion-examenes",
    name: "InscripcionExamen",
    component: InscripcionExamen
  },
  {
    path: "/materias-faltan",
    name: "MateriasFaltan",
    component: Faltan
  },
  {
    path: "/parciales-examenes",
    name: "ParcialExamen",
    component: ParcialExamen
  },
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.token !== '';

  if (!isAuthenticated && to.meta.requiresAuth) {
    // Almacenar el callback en el almacenamiento local
    localStorage.setItem('callback', to.path);
    next({ path: '/login' });
  } else {
    next();
  }
});

export default router;
